

export const formComponents = [
  {
    itemLabel: '单行文本',
    layout: 'colFormItem',
    itemType: 'el-input',
    tagIcon: 'input',
    placeholder: '请输入',
    defaultValue: undefined,
    span: 12,
    labelWidth: null,
    style: { width: '100%' },
    clearable: true,
    prepend: '',
    append: '',
    'prefix-icon': '',
    'suffix-icon': '',
    maxlength: 10,
    showWordLimit: false,
    readonly: false,
    disabled: false,
    required: true,
    regList: [],
    changeTag: true,
    document: 'https://element.eleme.cn/#/zh-CN/component/input'
  }
]
export const areaComponents = [
  {
    itemLabel: '数据表格',
    layout: 'normalTableItem',
    itemType: 'normal-table',
    itemRef: 'xrTable',
    orderNum: 1,
    interfaceCategoryId: '',
    interfaceCategoryName: '',
    dataServerKey: '',
    tableHeight: '',
    isShowSearch: 0,
    columnList: [],
    toolbarList: [],
    configure:{
      url: '',
      listParam: {},
      isShowSearch: false,
      tableHeight: 200,
      columns: [],
      toolbar: []
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/PageDesigner/utils/config.js